
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./styles/index.css";
import "./i18n"; // initialize react-i18next with bundled en + de locales
import { initSentry } from "./services/sentryInit";
import { initAnalytics } from "./services/analytics";
import { initThemeFromStorage } from "./app/components/ThemeToggle";

// Initialize Sentry before rendering — no-op if VITE_SENTRY_DSN is not set
initSentry();

// Initialize PostHog analytics — no-op if VITE_POSTHOG_KEY is not set (#50)
initAnalytics();

// Apply persisted theme BEFORE first render to avoid flash-of-unstyled-theme.
// Reads `localStorage.adjudon_theme`; defaults to "editorial-dark". Legacy
// "obsidian" values are silently migrated to "editorial-dark".
initThemeFromStorage();

createRoot(document.getElementById("root")!).render(<App />);
